import SellPaymentsContainer from './SellPaymentsModal.container';

export default SellPaymentsContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/index.js